
import { NJButton, NJIcon, NJMenuRoot, NJMenuGroup, NJMenuAnchor, NJMenuDropdown, NJMenuItem } from '@engie-group/fluid-design-system-react';
import React, { useState } from 'react';
import './SaveJobAdTemplate.css';
import ModalSaveJobAd from '../ModalSaveJobAd';


const SaveJobAdTemplate = ({ jobAdTitle, isTemplate, handleSave, allowSaveTemplate }) => {

    const [menuOpen, setMenuOpen] = useState(false);
    const [modalOpen, setModalOpen] = useState(false);

    const handleMenuClick = (saveAs) => {
        setMenuOpen(false);
        if (saveAs) {
            setModalOpen(true);
        }
        else {
            handleSave({ title: jobAdTitle, create: false });
        }
    }

    const handleModalSave = (name) => {
        setModalOpen(false);
        handleSave({ title: name, create: true });
    }

    const onClickSaveButton = () => {
        if (isTemplate || !allowSaveTemplate) {
            // If job ad is a template or saving templates is not allowed, save directly
            // If edition a template, don't show menu and save directly
            handleSave({ title: jobAdTitle, create: false });
        }
        else {
            setMenuOpen(!menuOpen);
        }
    }

    return (
        <>
            <ModalSaveJobAd
                isOpen={modalOpen}
                title={jobAdTitle}
                isTemplate={isTemplate}
                handleCancel={() => setModalOpen(false)}
                handleSave={handleModalSave}
            />
            <NJMenuRoot
                floatingRole="menu"
                opened={menuOpen}
                initialOpened={false}

            >
                <NJMenuAnchor>
                    <NJButton
                        label="Save"
                        emphasis="subtle"
                        variant="primary"
                        icon="save"
                        iconClassName="material-icons-outlined"
                        onClick={onClickSaveButton}
                    />
                </NJMenuAnchor>
                <NJMenuDropdown>
                    <NJMenuGroup >
                        <NJMenuItem
                            asChild
                            leading={<NJIcon name="content_paste" />}
                        >
                            <button onClick={() => { handleMenuClick(true) }}>
                                Save as template
                            </button>
                        </NJMenuItem>
                        <NJMenuItem asChild leading={<NJIcon name="save" />}>
                            <button onClick={() => { handleMenuClick(false) }}>
                                Save
                            </button>
                        </NJMenuItem>
                    </NJMenuGroup>
                </NJMenuDropdown>
            </NJMenuRoot>
        </>
    )
}

export default SaveJobAdTemplate;